import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingIndicatorService {

  private visibility: BehaviorSubject<boolean>;
  private loadingMessage: BehaviorSubject<string>;

  constructor(private translation: TranslateService) {
    this.visibility = new BehaviorSubject<boolean>(false);
    this.loadingMessage = new BehaviorSubject<string>(this.translation.instant('Loading'));
  }

  public show(loadingMessage?: string): void {
    if (loadingMessage != undefined) {
      this.loadingMessage.next(loadingMessage + '...');
    } else {
      this.loadingMessage.next(this.translation.instant('Loading') + '...');
    }
    this.visibility.next(true);
  }

  public hide(): void {
    this.visibility.next(false);
  }

  public getVisibility(): boolean {
    return this.visibility.getValue();
  }

  public getLoadingMessage(): string {
    return this.loadingMessage.getValue();
  }
}
